import React from 'react';
import CardList from '../components/CardsList';

const TelaPrincipal = ({ dataCards, abrirCard, urlProbabilidadeInternacao }) => {

  const renderCardRow = (items) => (
    <div className="row">
      {items.map((item) => {
        const infoCard = dataCards[item.tipo] ?? null;

        return (
          <div key={item.tipo} className="col-md-3" onClick={() => abrirCard(item.tipo)}>
            {item.card({ infoCard })}
          </div>
        );
      })}
    </div>
  );

  return (
    <>
      {renderCardRow(CardList.slice(0, 4))}
      {renderCardRow(CardList.slice(4, 8))}
      {urlProbabilidadeInternacao && (
        <div className="row row-links">
          <a
            className="btn-probabilidade-internacao"
            href={urlProbabilidadeInternacao}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/img/chart-no-axes-column.svg" alt="" />
            Probab. de Internação
            <img src="/img/arrow-up-right.svg" alt="" />
          </a>
        </div>
      )}
    </>
  );
};

export default TelaPrincipal;